// src/App.js
import React from 'react';
import StockAlerts from './SmartStockAlert';
import SmartStockAlert from './SmartStockAlert';

function App() {
  return (
    <div className="App">
      <SmartStockAlert />

    </div>
  );
}

export default App;